(function () {
  var roots = document.querySelectorAll('[data-tn-collections]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.init === '1') return;
    root.dataset.init = '1';

    var container = root.querySelector('.tn-bestsellers__container');
    var track     = root.querySelector('.tn-bestsellers__track');
    var cards     = Array.from(root.querySelectorAll('.tn-bestsellers__card'));
    var btnLeft   = root.querySelector('.tn-bestsellers__nav--left');
    var btnRight  = root.querySelector('.tn-bestsellers__nav--right');

    if (!container || !track || cards.length === 0 || !btnLeft || !btnRight) return;

    function paddingLeft() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function leftForCard(el){ return Math.max(0, el.offsetLeft - paddingLeft()); }

    function hasOverflow(){
      return (track.scrollWidth - container.clientWidth) > 1;
    }
    function atStart(){ return track.scrollLeft <= 1; }
    function atEnd(){
      return Math.ceil(track.scrollLeft) >= (track.scrollWidth - container.clientWidth - 1);
    }

    function currentIndex(){
      var sl = track.scrollLeft, idx = 0, best = Infinity;
      for (var i = 0; i < cards.length; i++){
        var t = leftForCard(cards[i]);
        var d = Math.abs(t - sl);
        if (d < best){ best = d; idx = i; }
      }
      return idx;
    }

    function nextIndex(){
      var sl = track.scrollLeft + 1;
      for (var j = 0; j < cards.length; j++){
        var t = leftForCard(cards[j]);
        if (t > sl) return j;
      }
      return cards.length - 1;
    }

    function prevIndex(){
      var sl = track.scrollLeft - 1;
      for (var j = cards.length - 1; j >= 0; j--){
        var t = leftForCard(cards[j]);
        if (t < sl) return j;
      }
      return 0;
    }

    function scrollToIndex(i){
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: leftForCard(cards[i]), behavior: 'smooth' });
    }

    function updateArrows(){
      var scrollable = hasOverflow();
      root.classList.toggle('tn-has-scroll', scrollable);
      btnLeft.classList.toggle('is-disabled',  !scrollable || atStart());
      btnRight.classList.toggle('is-disabled', !scrollable || atEnd());
    }

    // Events
    btnRight.addEventListener('click', function(){ scrollToIndex(nextIndex()); });
    btnLeft .addEventListener('click', function(){ scrollToIndex(prevIndex()); });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });

    // Recalculate after images load
    Array.from(track.querySelectorAll('img')).forEach(function(img){
      if (!img.complete) img.addEventListener('load', updateArrows, { once: true });
    });

    // Observe size changes
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(updateArrows);
      ro.observe(track);
      ro.observe(container);
    }

    // Initial + delayed passes
    updateArrows();
    requestAnimationFrame(updateArrows);
    setTimeout(updateArrows, 250);
    setTimeout(updateArrows, 1000);
  });
})();